import { DeutschLogo } from '@/assets/logos/DeutschLogo';
import { DoordashLogo } from '@/assets/logos/DoordashLogo';
import { EASportsLogo } from '@/assets/logos/EASportsLogo';
import { NetflixLogo } from '@/assets/logos/NetflixLogo';
import { OnnitLogo } from '@/assets/logos/OnnitLogo';
import { PlutoTVLogo } from '@/assets/logos/PlutoTVLogo';
import { ToyotaLogo } from '@/assets/logos/ToyotaLogo';
import React from 'react';
import DynamicMarquee from '@/components/DynamicMarquee';

export const BrandsCarousel = ({ title = 'Trusted by industry leaders' }) => {
  const logos = [
    {
      id: 'netflix',
      name: 'Netflix',
      info: '',
      logo: NetflixLogo,
    },
    {
      id: 'deutsch',
      name: 'Deutsch',
      info: '',
      logo: DeutschLogo,
    },
    {
      id: 'ea_sports',
      name: 'EA Sports',
      info: '',
      logo: EASportsLogo,
    },
    {
      id: 'toyota',
      name: 'Toyota',
      info: '',
      logo: ToyotaLogo,
    },
    {
      id: 'doordash',
      name: 'DoorDash',
      info: '',
      logo: DoordashLogo,
    },
    {
      id: 'pluto_tv',
      name: 'Pluto TV',
      info: '',
      logo: PlutoTVLogo,
    },
    {
      id: 'onnit',
      name: 'Onnit',
      info: '',
      logo: OnnitLogo,
    },
  ];

  return (
    <section className="container mx-auto px-6 md:px-16">
      <div className="px-[25px] py-5 flex flex-col gap-y-[30px] bg-white shadow-container rounded-2xl">
        <p className="text-center font-bold text-lg">{title}</p>
        <div className="block">
          <DynamicMarquee>
            {logos.map(({ id, logo: Logo }) => (
              <Logo key={id} className="mx-4 fill-tertiary-gray" />
            ))}
          </DynamicMarquee>
        </div>
      </div>
    </section>
  );
};
